module.exports = "<div class=\"bread-crumbs-nav\">\r\n    您的位置：\r\n    <a routerLink=\"/home\" class=\"c002\">首页</a> >\r\n    <span *ngFor=\"let item of linkParam\">\r\n        <a *ngIf=\"!item.isEnd\" class=\"c002\" routerLink=\"{{item.link}}\">{{item.linkText}}</a>\r\n        <span *ngIf=\"!item.isEnd\"> > </span>\r\n        <span *ngIf=\"item.isEnd\">{{item.linkText}}</span>\r\n    </span>\r\n\r\n</div>"


//////////////////
// WEBPACK FOOTER
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/shared/components/breadCrumbs/breadCrumbs.component.html
// module id = ../../../../../src/app/shared/components/breadCrumbs/breadCrumbs.component.html
// module chunks = main